import { render, staticRenderFns } from "./ModalFood.vue?vue&type=template&id=58309c0a"
import script from "./ModalFood.vue?vue&type=script&lang=js"
export * from "./ModalFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports